var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _path, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12.5,
    width: 50,
    height: 32,
    rx: 2,
    fill: "#1B3380"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 62,
    height: 62,
    rx: 7,
    stroke: "#1B3380",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 18.5,
    width: 32,
    height: 2,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 22.5,
    width: 17,
    height: 2,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 27.5,
    width: 42,
    height: 12,
    rx: 1,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 38.5,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 30.5C19.5817 30.5 16 34.0817 16 38.5C16 42.9183 19.5817 46.5 24 46.5C28.4183 46.5 32 42.9183 32 38.5C32 34.0817 28.4183 30.5 24 30.5Z",
    fill: "#1B3380"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 49.1667C13.9695 49.1667 8 55.1362 8 62.5H40C40 55.1362 34.0305 49.1667 26.6667 49.1667H21.3333Z",
    fill: "#1B3380"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 21.5,
    r: 3,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenter);
export default __webpack_public_path__ + "static/media/presenter.1a7fa35d037306fd514c8ab030b4ca88.svg";
export { ForwardRef as ReactComponent };